import { render } from "./AdultsSectionFour.vue?vue&type=template&id=5090fb01&scoped=true"
import script from "./AdultsSectionFour.vue?vue&type=script&lang=js"
export * from "./AdultsSectionFour.vue?vue&type=script&lang=js"

import "./AdultsSectionFour.vue?vue&type=style&index=0&id=5090fb01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5090fb01"]])

export default __exports__